import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import "./contact.css";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAIL_SERVICE_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAIL_API_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully",
          });
        },
        (error) => {
          console.log(error.text);
          Swal.fire({
            icon: "error",
            title: "Ooops, something went wrong",
            text: error.text,
          });
        }
      );
    e.target.reset();
  };

  const [fromDate, setFromoDate] = useState();
  const [toDate, setToDate] = useState();

  return (
    <section className="contact container section" id="contact">
      <h2 className="section__title">Contact Me</h2>
      <div className="contact__container grid">
        <div className="contact__info">
          <h3 className="contact__title">Let's talk about your paws</h3>
          <p className="contact__details">Don't like forms? Send me an email </p>
          <p className="contact__details_email">Email: loveDogsitting@gmail.com </p>
        </div>

        <form ref={form} onSubmit={sendEmail} className="contact__form">
          <div className="contact__form-group">
            <div className="contact__form-div">
              <input
                type="text"
                name="client_name"
                className="contact__form-input"
                placeholder="Your name"
              />
            </div>

            <div className="contact__form-div">
              <input
                type="email"
                name="client_email"
                className="contact__form-input"
                placeholder="Your email"
              />
            </div>
          </div>
          <div className="contact__form-group">
            <div className="contact__form-div">
              <input
                type="text"
                name="client_phone"
                className="contact__form-input"
                placeholder="Your phone number"
              />
            </div>

            <div className="contact__form-div">
              <input
                type="text"
                name="client_location"
                className="contact__form-input"
                placeholder="Your location"
              />
            </div>
          </div>
          <div className="contact__form-date">
            <div>
              <h1 className="date-title">Select Date (optional)</h1>
              From{" "}
              <input
                className="form-date"
                type="date"
                name="from_date"
                onChange={(e) => setFromoDate(e.target.value)}
              />{" "}
              To{" "}
              <input
                className="form-date"
                type="date"
                name="to_date"
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>
          <div className="contact__form-div contact__form-area">
            <textarea
              name="message"
              id=""
              cols="30"
              rows="10"
              className="contact__form-input"
              placeholder="Write your message"
            />
          </div>
          <button type="submit" value="Send" className="btn">
            Submit
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
